<template>
  <div>
    <div v-if="editMode">
      <!--<el-time-select
        ref="time_selector"
        class="inline-time-select"
        v-bind:value="selectedTime"
        v-on:input="onInput"
        :placeholder="placeholder"
        :size="size"
        :picker-options="timePickerOptions"
        @change="onUpdate"
        @blur="onUnfocus">
      </el-time-select>
      <el-button
        v-if="show_confirm_button"
        size="mini"
        type="success"
        @click="onSave"
        v-on:input="onInput"
        style="position: relative">ok</el-button>-->
        <el-time-picker
          class="inline-time-select"
          @change="onUpdate"
          @blur="onUnfocus"
          ref="time_selector"
          v-model="selectedTime"
          :picker-options="timePickerOptions"
          :placeholder="placeholder"
          >
        </el-time-picker>
    </div>
    <template v-if="!editMode">
      <div v-if="selectedTime" style="display: flex; flex-wrap: nowrap">
        <div @click.prevent="onStartEditMode">
          <div class="time-selector-inline-timer">
            <div class="time-selector-inline-timer__time">{{ hours }}</div>
            <div class="time-selector-inline-timer__low">h</div>
            <div class="time-selector-inline-timer__time">{{ minutes }}</div>
            <div class="time-selector-inline-timer__low">m</div>
            <div class="time-selector-inline-timer__time">{{ seconds }}</div>
            <div class="time-selector-inline-timer__low">s</div>
          </div>
          </div>
        </div>
        <div v-else>
          <a href="#" @click.prevent="onStartEditMode">
            not set
          </a>
        </div>
    </template>
  </div>
</template>

<script>
/* This component can not handle user timezone... which is probably fine,
   but wherever timeSelectorInline is used, the results still might need
   conversion. */

import moment from '@/moment-gp'

const timePickerOptionsDefault = {
  selectableRange: '00:00:00 - 23:59:59'
};

export default {
  props: {
    show_confirm_button: {
      default: false
    },
    placeholder: {
      default: 'Select time'
    },
    value: {
      default: () => ([])
    },
    timePickerOptions: {
      default: () => (timePickerOptionsDefault)
    }
  },
  data: () => ({
    editMode: false,
    selectedTime: null,
  }),
  mounted() {
    console.log('mounted', this.value)
    this.selectedTime = moment.utc(this.value * 1000);
    console.log(this.selectedTime)
  },
  computed: {
    hours() {
      return moment(this.selectedTime).format('hh')
    },
    minutes() {
      return moment(this.selectedTime).format('mm')
    },
    seconds() {
      return moment(this.selectedTime).format('ss')
    }
  },
  methods: {
    onStartEditMode() {
      this.editMode = !this.editMode;
      this.$nextTick(() => {
        this.$refs.time_selector.focus();
      })
    },

    onUpdate() {
      // this.$emit('input', this.selectedTime);  <<<< WORKAROUND
      if ( !this.show_confirm_button ) {
        this.onSave();
      }
    },

    onInput($event) {
      console.log('onInput', $event);
      this.selectedTime = $event;
    },

    onSave() {
      console.log(' this.selectedTime',  this.selectedTime)
      this.editMode = false;
      let time = moment(this.selectedTime)
      var duration = time.hours() * 3600 + time.minutes() * 60 + time.seconds()
      console.log('duration', duration)
      this.$emit('save', duration)
    },

    onUnfocus() {
      this.editMode = false;
    }
  }
}
</script>

<style>
.time-selector .inline-time-select {
  display: inline-block;
  margin: 0 0.1em;
  width: 8em;
}
.time-selector {
  display: inline-block;
  position: relative;
}
.time-selector .el-checkbox-button {
  margin-bottom: 0;
}
.time-selector-helper {
  font-size: 9pt;
}
.time-selector-inline-timer {
  font-size: 22pt;
  font-weight: bold;
  display: flex;
  align-items: flex-end;
  flex-wrap: nowrap;
}
.time-selector-inline-timer__time {
  margin: 0;
  padding: 0;
}
.time-selector-inline-timer__low {
  font-size: 10pt;
  margin: 0;
  padding: 0;
  padding-bottom: 0.4em
}
</style>
